export default "__VITE_ASSET__BOE4qTlG__"